// extracted by mini-css-extract-plugin
export var infoRow = "_oh-2";
export var labelContainer = "_oh-0";
export var rightInfo = "_oh-1";